import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_HOMES = `${HOME_SERVICE}/account-pricing`;

export const accountPricing = {
  getAll: async ({ accountId }) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${accountId}/categories`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  getById: async ({ accountId, categoryId }) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${accountId}/categories/${categoryId}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  update: async ({ accountId, categoryId, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${accountId}/categories/${categoryId}`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  updateAll: async ({ accountId, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${accountId}/categories`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  dropDraws: {
    getAll: async ({ accountId }) => {
      const options = await apiOptions({
        url: `${API_HOMES}/${accountId}/drop-draws`,
        method: "get",
        headers: { [X_API_VERSION]: API_VERSION },
      });
      return apiRequest(options);
    },
    updateAll: async ({ accountId, data, toastMessageConfig }) => {
      const options = await apiOptions({
        url: `${API_HOMES}/${accountId}/drop-draws`,
        method: "put",
        headers: { [X_API_VERSION]: API_VERSION },
        data,
      });
      return apiRequest(options, toastMessageConfig);
    },
  },
};
